/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type V2TriggerInstanceState =
  (typeof V2TriggerInstanceState)[keyof typeof V2TriggerInstanceState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V2TriggerInstanceState = {
  TRIGGER_INSTANCE_STATE_PENDING: 'TRIGGER_INSTANCE_STATE_PENDING',
  TRIGGER_INSTANCE_STATE_READY: 'TRIGGER_INSTANCE_STATE_READY',
  TRIGGER_INSTANCE_STATE_FAILED: 'TRIGGER_INSTANCE_STATE_FAILED',
  TRIGGER_INSTANCE_STATE_UNKNOWN: 'TRIGGER_INSTANCE_STATE_UNKNOWN',
} as const;
